import { styled } from "theme/default/styled";
import { setFlexDFF1 } from "theme/setter/setFlexValues/setFlexDFF1";

export const STableHeaderContainer = styled.div`
  width: fit-content;

  ${setFlexDFF1};
`;
